import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background } = colors;

export default makeStyles((theme) => ({
  "@keyframes slideUp": {
    from: {
      transform: "translateY(70vh)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },

  container: {
    position: "fixed",
    width: "100%",
    maxWidth: 480,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    padding: 20,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
    backgroundColor: background?.default || "#FDFCF8",
    animation: "$slideUp 0.6s ease-out",
    maxHeight: "85vh",
    overflowY: "auto",
    zIndex: 1300,
  },

  containerChildren: {
    height: "auto",
    paddingBottom: 20,
  },

  closeButton: {
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0,0.05)",
    transition: "background-color 0.2s ease",
    width: "40px",
    height: "40px",
    position: "absolute",
    zIndex: 1000,
    top: 18,
    right: 18,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.1)",
    },
  },
}));

